import { useState } from 'react';
import { DebouncedFullScreenLoader } from 'components';
import { LinkNewSpeakingSession } from './LinkNewSpeakingSession';
import { useLinkSpeakingSession } from './useLinkSpeakingSession';
import { LinkExistingSpeakingSession } from './LinkExistingSpeakingSession';

export const LinkSpeakingSession = () => {
  const { availableSpeakingSessions, isLoadingAvailableSessions, canLinkSpeakingSession } =
    useLinkSpeakingSession();

  const [isCreatingNewSession, setIsCreatingNewSession] = useState(false);

  if (!canLinkSpeakingSession) return null;

  if (!availableSpeakingSessions || isLoadingAvailableSessions)
    return <DebouncedFullScreenLoader />;

  const hasAvailableSessions = availableSpeakingSessions.length > 0;

  return !hasAvailableSessions || isCreatingNewSession ? (
    <LinkNewSpeakingSession hasAvailableSessions={hasAvailableSessions} />
  ) : (
    <LinkExistingSpeakingSession
      availableSpeakingSessions={availableSpeakingSessions}
      onCreateNewSpeakingSession={() => setIsCreatingNewSession(true)}
    />
  );
};
